<template>
    <div id="mainMenu" class="pure-menu custom-restricted-width">

        <span class="pure-menu-heading" v-if="isInRole([ 'customer_admin', 'customer_user' ])" >Inventur</span>

        <ul class="pure-menu-list">
            <li class="pure-menu-item"><a class="pure-menu-link main-menu-item" v-on:click="navigateEdit()" >Bearbeiten</a></li>
            <li class="pure-menu-item" v-if="isInRole([ 'customer_user', 'customer_admin' ])"><a class="pure-menu-link main-menu-item" v-on:click="navigateStatistic()" >Statistik</a></li>
            <li class="pure-menu-item" v-if="isInRole([ 'customer_admin' ])"><a class="pure-menu-link main-menu-item" v-on:click="navigateClose()" >Abschlu&szlig;</a></li>
        </ul>

        <ul style="padding-top: 20px" v-if="stocktaking != null" class="pure-menu-list">
            <li class="menu-info">Filiale: {{ stocktaking.store }}</li>
            <li class="menu-info">Datum: {{ new Date(stocktaking.date).toLocaleDateString('de-DE', dateOptions) }}</li>
        </ul>

    </div>
</template>

<script>
import { hasRole } from '@/utils/auth.js'
import { getJwt } from '@/utils/auth.js'
import axios from "axios"
import router from '@/router.js'

export default {
    name: 'StocktakingMenu',
    props: {
        url: ""
    },
    data: function() {
        return {
            stocktaking: null,
            dateOptions: {  year: 'numeric', month: '2-digit', day: '2-digit' }
        }
    },
    mounted: function() {

        console.log(this.$props.url)
        this.loadData(this.$props.url)
    },
    methods: {

        loadData: function(url) {

            axios({
                method: "GET",
                url: url,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + getJwt()
                }
            }).then(
                result => {
                    console.log(result.data)

                    this.stocktaking = result.data
                },
                error => {
                    console.error(error.response.data.status)
                })

        },
        isInRole: function(roles) {

            return hasRole(roles)
        },
        navigateStatistic: function() {

            router.push({
                name: "stocktakingStatisticView",
                params: {
                    url: this.url
                }
            });
        },
        navigateEdit: function () {

            router.push({
                name: "editStocktakingView",
                params: {
                    url: this.url
                }
            });
        },
        navigateClose: function () {

            router.push({
                name: "stocktakingCloseView",
                params: {
                    url: this.url
                }
            });
        }
    }
}
</script>

<style>

#mainMenu {
    background-color: #6699cc;
    color: white;
    min-height: calc(100vh - 70px);
    padding-top: 40px;
    
}

#mainMenu .pure-menu-link {
    color: white;
    font-size: 1.1rem;
    padding-top: 6px;
    padding-bottom: 6px;
}

#mainMenu .pure-menu-link:hover {
    background-color: #003366;
}

#mainMenu .pure-menu-link:focus {
    background-color: #003366;
}

#mainMenu .pure-menu-heading {
    color: #003366;
}

</style>
